import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Breadcrumb, Empty, Alert, Input, Button } from "antd";
import Grid from "@material-ui/core/Grid";
import AddOverrideButton from "./AddOverrideButton";
import OverrideCard from "./OverrideCard";
import { fetchOverrides } from "../../../redux/Overrides/actions";

const { Search } = Input;

export const Overrides = () => {
  const dispatch = useDispatch();
  const overrides = useSelector((state) => state.overrides.overrides || []);
  const [overrideSearch, setOverrideSearch] = useState([]);
  const [searchMode, setSearchMode] = useState(false);
  const error = useSelector((state) => state.overrides.error);

  // State variable to trigger refetch
  const [refreshFlag, setRefreshFlag] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchOverrides());
      } catch (err) {
        console.error("Failed to fetch overrides:", err);
      }
    };
    fetchData();
  }, [dispatch, refreshFlag]); // Re-run the effect when refreshFlag changes

  const handleRefresh = () => {
    setRefreshFlag(!refreshFlag);
  };

  const overrideSearchFun = (value) => {
    if (value.length > 0) {
      setSearchMode(true);
      const filteredOverrides = overrides.filter((el) =>
        el.name.toLowerCase().includes(value.toLowerCase())
      );
      setOverrideSearch(filteredOverrides);
    } else {
      setSearchMode(false);
      setOverrideSearch([]);
    }
  };

  return (
    <div>
      {error && (
        <Alert
          message="Error"
          description={error}
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Overrides</Breadcrumb.Item>
        <div style={{ float: "right", marginTop: 20 }}>
          <Grid container>
            <Grid item>
              <Search
                placeholder="Search"
                onChange={(e) => {
                  if (e.target.value.length === 0) setSearchMode(false);
                }}
                style={{ minWidth: 150, maxWidth: 220 }}
                enterButton
                onSearch={overrideSearchFun}
              />
              {/* Pass handleRefresh to child components */}
              <AddOverrideButton onRefresh={handleRefresh} />
            </Grid>
          </Grid>
        </div>
      </Breadcrumb>
      <br />
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container justify="center" spacing={2}>
            {searchMode ? (
              overrideSearch.length === 0 ? (
                <Empty />
              ) : (
                overrideSearch.map((item, index) => (
                  <Grid key={index} item>
                    <OverrideCard item={item} onRefresh={handleRefresh} />
                  </Grid>
                ))
              )
            ) : overrides && overrides.length > 0 ? (
              overrides.map((item, index) => (
                <Grid key={index} item>
                  <OverrideCard item={item} onRefresh={handleRefresh} />
                </Grid>
              ))
            ) : (
              <Empty />
            )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Overrides;
